import { render, staticRenderFns } from "./prjNotice.vue?vue&type=template&id=26ff9b84&scoped=true"
import script from "./prjNotice.vue?vue&type=script&lang=js"
export * from "./prjNotice.vue?vue&type=script&lang=js"
import style0 from "./prjNotice.vue?vue&type=style&index=0&id=26ff9b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ff9b84",
  null
  
)

export default component.exports